import { get } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IM_PAYING_MYSELF } from '@zocdoc-frontend-common/components-insuranceform';
import { useCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { handleShareInsuranceCheckboxChange } from 'src/Booking/actions/InsuranceCardActions';
import { InsuranceCardScannerSectionView } from 'src/Booking/components/InsuranceCardScannerSection/InsuranceCardScannerSectionView';
import { BookingStateProperties } from 'src/Booking/constants';
import { submitScanCardHelper } from 'src/Booking/pages/ReviewAndBook/helpers';
import bookingStateSelector from 'src/Booking/selectors/BookingStateSelector';
import patientSelector from 'src/Booking/selectors/PatientSelector';
import reviewAndBookScanCardStateSelector from 'src/Booking/selectors/ReviewAndBookScanInsuranceCardSelector';

/**
 * @param onScanInsuranceCardImagesSuccess {function} handles what to do with insurance cards once successfully scanned in scanner
 * @param setScannedCardScannerOpenState {function} will set scanner open state to be true or false
 * @param setScannedCardLoadingState {function} will set the loading state to be true or false
 * @returns {JSX.Element}
 */
export const InsuranceCardScannerSectionContainer = ({
    onScanInsuranceCardImagesSuccess,
    setScannedCardScannerOpenState,
    setScannedCardLoadingState,
}) => {
    const bookingState = useSelector(bookingStateSelector);
    const isInsuranceCardShared = get(
        bookingState,
        BookingStateProperties.isInsuranceCardShared,
        false
    );
    const insuranceCarrierId = get(
        bookingState,
        BookingStateProperties.insuranceCarrierId,
        IM_PAYING_MYSELF
    );
    const insurancePlanId = get(
        bookingState,
        BookingStateProperties.insurancePlanId,
        '0'
    );
    const patient = useSelector(patientSelector);
    const scanCardState = useSelector(reviewAndBookScanCardStateSelector);
    const isScannerOpen = scanCardState.isScannerOpen;
    const isLoading = scanCardState.isScannerLoading;
    const hasFetchError = scanCardState.hasFetchError;

    const imgSrcFront =
        patient.selectedInsuranceCard?.insuranceCardImageUrls?.front;
    const imgSrcBack =
        patient.selectedInsuranceCard?.insuranceCardImageUrls?.back;
    const sendMetric = useCustomMetrics({
        component: 'Booking',
        section: 'InsuranceCardScannerSection',
    });
    const dispatch = useDispatch();
    const onShareInsuranceCheckboxChange = (event) => {
        dispatch(handleShareInsuranceCheckboxChange(event.target.checked));
    };

    const submitScanCard = (response) => {
        submitScanCardHelper({
            response,
            actualCarrierId: insuranceCarrierId,
            actualPlanId: insurancePlanId,
            onScanInsuranceCardImagesSuccess,
            sendMetric,
        });
    };

    const viewProps = {
        imgSrcFront,
        imgSrcBack,
        isInsuranceCardShared,
        sendMetric,
        onShareInsuranceCheckboxChange,
        onClickContinue: submitScanCard,
        isScannerOpen,
        isLoading,
        setScannedCardScannerOpenState,
        setScannedCardLoadingState,
        hasFetchError,
    };
    return <InsuranceCardScannerSectionView {...viewProps} />;
};
